<!-- Modal Form ADD User Credit 
<ng-template #dialogAddUserCredit let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Add/Remove Credit</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #userCreditForm="ngForm" (ngSubmit)="sendUserCredit(userCreditForm)" class="form-vehicle">
      <div class="row">
        <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" translate>customer.credit</span>
          </div>
          <input type="number" class="form-control" id="credit" name="credit" ngModel>
          <button type="submit" class="form-control btn btn-block btn-success" translate>global.save</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>-->

<div *ngIf="applications" class="card-body">
  <div class="all-app d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <h3 class="card-title" translate>Clients</h3>
    </div>

    <div class="d-flex align-items-center flex-row justify-content-end">
      <button type="button" class="custom-button add-button" (click)="onAddClient()" translate>customer.newClient<i
          class="fa fa-plus" style="margin-left: 7px;"></i></button>
    </div>
  </div>

  <app-clients-search-fields (onSearch)="searchClients($event)"></app-clients-search-fields>

  <div class="my-4">
    <div class="row">
      <app-client-item
        *ngFor="let application of applicationsDataSearch | slice: (clientPage-1) * clientPerPage : (clientPage-1) * clientPerPage + clientPerPage"
        [application]="application" [selectedApp]="selectedApp" [currentUser]="currentUser"
        (onShowUsers)="showUsers($event)" (editClient)="onEditClient($event)" (invoiceConfig)="onInvoiceConfig($event)"
        (changeCustomer)="onChangeCustomer($event)" (sshSetup)="onSshSetup($event)" [customerSettings]="customerSettings" [customerId]="customerId"
        class=" col-lg-4 col-md-6 col-sm-12">
      </app-client-item>
    </div>
    <div class="clearfix w-100"></div>
    <ngb-pagination *ngIf="applicationsDataSearch && applicationsDataSearch.length"
      [collectionSize]="applicationsDataSearch.length" [(pageSize)]="clientPerPage" [(page)]="clientPage" [maxSize]="5"
      [rotate]="true" (pageChange)="jumpToClientPage($event)"></ngb-pagination>
  </div>
</div>
<div *ngIf="applications && !applications.length" class="no_clients p-3">
  <p translate>customer.noClients</p>
  <!-- <button class="custom-button" (click)="toggleAddClient = true" translate>customer.newClient</button> -->
</div>
<div class="clearfix" style="width: 100%"></div>
<hr class="separate">

<div id="target" style="min-height: 20px;">
  <app-client *ngIf="selectedApp && usersDataSearch && !isLoading" [clientData]="selectedApp"
    [secondProfilesOnThePage]='true' (reloadClients)="loadClients($event)" (credit)="onChangeCredit($event)"
    [applications]="applications" [applicationsAll]="applicationsAll"></app-client>

</div>

<app-modal (close)="toggleAddClient = false" *ngIf="toggleAddClient">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>customer.newClient</p>

    <form #applicationForm="ngForm" class="form-vehicle">

      <!-- Name -->
      <div class="form-group">
        <label class="m-0" translate>global.name</label>
        <input type="text" #name="ngModel" autocomplete="off" required [ngModel]="client.name" class="form-control"
          [class.is-invalid]="name.invalid && name.touched" name="name">
      </div>

      <!-- Email -->
      <div class="form-group">
        <label class="m-0" translate>customer.email</label>
        <input type="text" #email="ngModel" autocomplete="off" [ngModel]="client.email" class="form-control"
          name="email">
      </div>

      <!-- Country -->
      <div class="form-group">
        <label class="m-0" translate>customer.country</label>
        <input type="text" #country="ngModel" autocomplete="off" [ngModel]="client.country" class="form-control"
          name="country">
      </div>

      <!-- City -->
      <div class="form-group">
        <label class="m-0" translate>customer.city</label>
        <input type="text" #city="ngModel" autocomplete="off" [ngModel]="client.city" class="form-control" name="city">
      </div>

      <!-- Address -->
      <div class="form-group">
        <label class="m-0" translate>customer.address</label>
        <input type="text" #address="ngModel" autocomplete="off" [ngModel]="client.address" class="form-control"
          name="address">
      </div>

      <!-- Post Code -->
      <div class="form-group">
        <label class="m-0" translate>customer.postCode</label>
        <input type="text" #postCode="ngModel" autocomplete="off" [ngModel]="client.postCode" class="form-control"
          name="postCode">
      </div>

      <!-- Notes -->
      <div class="form-group">
        <label class="m-0">Notes</label>
        <input type="text" #notes="ngModel" autocomplete="off" [ngModel]="client.notes" class="form-control"
          name="notes">
      </div>

      <!-- Description -->
      <div class="form-group">
        <label class="m-0" translate>customer.description</label>
        <input type="text" #description="ngModel" autocomplete="off" [ngModel]="client.description" class="form-control"
          name="description">
      </div>

      <div class="form-group">
        <label class="m-0">Payment</label>
        <select class="form-control" name="paymentType" [ngModel]="client.paymentType">
          <option value="prepaid">Prepaid</option>
          <option value="postpaid">Postpaid</option>
        </select>
      </div>

      <div *ngIf="currentUser.role.name === 'root'" class="form-group">
        <p translate>Postponed Invoice</p>
        <div class="choose-window">
          <p translate>Disable</p>
          <label class="switch_checkbox">
            <input style="display: none;" type="checkbox" name="postponedInvoiceEnabled"
              [ngModel]="client.postponedInvoiceEnabled">
            <span class="slider round"></span>
          </label>
          <p translate>Enable</p>
        </div>
      </div>

      <!-- LOGO -->
      <div class="form-group">
        <p class="mb-2" *ngIf="previewImage">Logo</p>
        <input id="logoFile" style="display: none;" type="file" (change)="getFile($event)" placeholder="Choose Image" />
        <div class="bg-files bg-hover client_logo" (click)="fileSelectorOpen()" *ngIf="previewImage != null"
          [style.background-image]="'url(' + previewImage + ')'">
        </div>
        <p *ngIf="!previewImage">Upload Logo</p>
        <div class="upload_container" (click)="fileSelectorOpen()" *ngIf="!previewImage"><i
            class="fa fa-upload upload_icon"></i></div>
      </div>

      <button class="custom-button" style="width: 120px;" *ngIf="client.isNew"
        (click)="sendApplication(applicationForm)" translate>global.save</button>
      <button class="custom-button w-100" *ngIf="!client.isNew" (click)="editClient(applicationForm)"
        translate>global.edit</button>

    </form>
  </div>
</app-modal>

<!-- Change Customer -->
<app-modal (close)="onCloseCustomer()" *ngIf="toggleChangeCustomer">
  <div class="modal_container black-text">
    <p class="text-header-modal">Change Customer</p>

    <div #searchContainer [ngClass]="{'active' : showCustomers}" class="div select-bg search-container w-100"
      style="display: block;">
      <input type="text" readonly class="search" style="height: 44px; display: block; width: 100%; padding-left: 12px;"
        (click)="openCustomers()" name="selectedPreset"
        [placeholder]="selectedCustomer ? selectedCustomer.name : 'Select Customer...'">

      <div class="form-group">
        <div class="prikaz" *ngIf="showCustomers">
          <div class="backdrop" (click)="openCustomers()"></div>
          <div style="z-index: 100; overflow-y: auto;">
            <div class="divider"></div>
            <input type="text" class="search-marke" (input)="applyCustomerFilter()"
              [attr.placeholder]="'user.search' | translate" name="searchCustomersParam" name="searchCustomersParam"
              [(ngModel)]="searchCustomersParam">
            <ul style="margin-bottom: 12px;">
              <li *ngFor="let customer of customersSearch"
                (click)="showCustomers=!showCustomers; selectCustomer(customer)">
                {{ customer.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div style="min-height: 100px;"></div>
    <p class="p-2" style="font-size: .93rem;" *ngIf="selectedCustomer">Move to {{selectedCustomer.name}}</p>

    <button style="width: 150px;" (click)="moveClient()" class="custom-button mt-3">SAVE</button>
  </div>
</app-modal>

<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Please wait...'"></div>
</div>

<app-modal class="custom-modal" (close)="toggleChangeInvoice = false" *ngIf="toggleChangeInvoice">
  <div class="modal_container black-text d-flex flex-column align-items-center">
    <p class="text-header-modal font-weight-bold mb-3" translate>Invoice Configuration</p>
    <div>
      <p class="mt-3 font-weight-bold" style="font-size: 1.2rem;">Select field
      </p>

      <div class="mx-2 row">
        <form class="row" #invoiceConfigForm="ngForm" (ngSubmit)="invoiceConfig(invoiceConfigForm)">
          <div class="col-6" *ngFor="let type of invoiceFields">
            <label class="custom-checkbox mt-3">
              <input class="custom-checkbox-input" ngModel [name]="type.name"
                [ngModel]="!!client.customInvoiceConfig?.columns?.includes(type.name)" type="checkbox">
              <span class="custom-checkbox-text">{{type.labelName}}</span>
            </label>
          </div>
          <div class="col-12">
            <button type="submit" class="custom-button btn-red mt-5" style="font-size: 1.2rem;">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-modal>

<app-modal class="custom-modal" (close)="toggleSSHSetup = false" *ngIf="toggleSSHSetup">
  <div class="modal_container black-text d-flex flex-column align-items-center">
    <p class="text-header-modal font-weight-bold mb-3" translate>SSH Configuration</p>
    <div class="mx-2 w-100">
      <ng-container *ngIf="isLoadingSSHKeys; else sshSetup">
        <div>Loading keys...</div>
      </ng-container>

      <ng-template #sshSetup>
        <div class="w-100 d-flex justify-content-end mb-3">
          <button type="button" class="custom-button add-button" (click)="onAddSSH()">Add SSH Key</button>
        </div>
        <ng-container *ngIf="sshKeys.length; else noKeys">
          <div class="d-flex flex-column w-100">
            <div class="d-flex justify-content-between my-2 p-2" style="letter-spacing: initial; background-color: #f3f3f3;"
              *ngFor="let key of sshKeys">
              <p
                style="flex: 3; line-height: initial; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; float: none;">
                {{key.name}}</p>
              <p style="flex: 1">{{key.type}}</p>
              <div style="flex: 1; gap: 0.5rem" class="d-flex align-items-center justify-content-end">
                <div style="cursor: pointer;" (click)="seeSSHPublicKey(key.id)"><i class="fa fa-eye" aria-hidden="true"></i></div>
                <div class="root-application-image-delete" (click)="onDeleteSSH(key)"></div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #noKeys>
        <div style="text-align: center;">There are no SSH keys.</div>
      </ng-template>
    </div>
  </div>
</app-modal>

<app-modal *ngIf="toggleDeleteSSH" (close)="toggleDeleteSSH = false">
  <div class="modal_container" style="text-align: initial; letter-spacing: 1px; font-weight: 100 !important; color: #15171a;">
    <div class="p-4">
      <p>Are you sure you want to delete SSH key?</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteSSHKey()"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="toggleDeleteSSH = false" translate>global.no</button>
  </div>
</app-modal>

<app-modal *ngIf="toggleAddSSH" (close)="toggleAddSSH = false">
  <div class="modal_container" style="text-align: initial; letter-spacing: initial; font-weight: 100 !important; color: #15171a;">
    <form [formGroup]="sshForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="name">Name:</label>
        <input type="text" id="name" formControlName="name" class="form-control" placeholder="Enter name..."
          [class.is-invalid]="sshForm.get('name').invalid && sshForm.get('name').touched">
        <small class="text-danger"
          [class.d-none]="sshForm.get('name').valid || sshForm.get('name').untouched">
          Name is required
        </small>
      </div>

      <div class="form-group">
        <label for="type">Type:</label>
        <select class="form-control" id="type" formControlName="type">
          <option value="dsa">dsa</option>
          <option value="ecdsa">ecdsa</option>
          <option value="ecdsa-sk">ecdsa-sk</option>
          <option value="ed25519">ed25519</option>
          <option value="ed25519-sk">ed25519-sk</option>
          <option value="rsa">rsa</option>
        </select>
        <small class="text-danger"
          [class.d-none]="sshForm.get('type').valid || sshForm.get('type').untouched">
          Type is required
        </small>
      </div>

      <div class="form-group" style="display: flex; flex-direction: column; gap: 1rem">
        <button class="btn btn-primary w-100" type="submit" [disabled]="!sshForm.valid">Add SSH Key</button>
      </div>
    </form>
  </div>
</app-modal>

<app-modal *ngIf="toggleSSHPublicKey" (close)="closeSSHInfo()">
  <div class="modal_container" 
    style="text-align: initial; letter-spacing: initial; font-weight: 100 !important; color: #15171a;">
    <div class="p-4">
      <ng-container *ngIf="isLoadingSSH; else SSHData">
        <p>Loading Data...</p>
      </ng-container>

      <ng-template #SSHData>
        <p>Public Key:</p>
        <div style="padding: 6px 15px; background: #efefef; border-radius: 6px; line-height: 1.4rem;">
          <span style="font-size: 0.85rem; word-break: break-word;">{{publicKey || 'No public key.'}}</span>
        </div>
      </ng-template>
    </div>
  </div>
</app-modal>
